export default __webpack_public_path__ + "static/media/spinner-purple.b9d273d9.svg";